import { useMemo } from 'react';
import AboutUsContext from './AboutUsContext';
import useFetchQuery from '../../../../hooks/useFetchQuery';

function AboutUsContextProvider({ children }) {
    const { data: platformRegulations = [], isLoading: isLoadingPlatformRegulations } = useFetchQuery({
        url: '/platform-regulations',
        method: 'get',
        onFetchSuccess: ({ data }) => {
            return data?.regulations?.map((item) => {
                return {
                    title: item?.general_info?.title,
                    description: item?.translations?.find((translation) => translation.lang_code === 'en')?.description,
                };
            });
        },
    });

    const { data: customerPlatformInfo = [], isLoading: isLoadingCustomerPlatformInfo } = useFetchQuery({
        url: '/customer-platform-info',
        method: 'get',
        onFetchSuccess: ({ data }) => {
            return data?.customer_platform_info?.map((item) => {
                return {
                    title: item?.general_info?.title,
                    description: item?.translations?.find((translation) => translation.lang_code === 'en')?.description,
                };
            });
        },
    });

    const { data = {}, isLoading } = useFetchQuery({
        url: '/about-us',
        method: 'get',
        onFetchSuccess: ({ data }) => {
            return data?.about_us?.translations?.find((translation) => translation.lang_code === 'en') || {};
        },
    });

    const contextValue = useMemo(() => {
        return {
            isLoading,
            about: data?.description,
            customerPlatformInfo,
            isLoadingCustomerPlatformInfo,
            platformRegulations,
            isLoadingPlatformRegulations,
        };
    }, [data, isLoading, customerPlatformInfo, isLoadingCustomerPlatformInfo, platformRegulations, isLoadingPlatformRegulations]);

    return <AboutUsContext.Provider value={contextValue}>{children}</AboutUsContext.Provider>;
}

export default AboutUsContextProvider;
